import { Link } from "react-router-dom";
import { Star, MessageCircle } from "lucide-react";
import { Button } from "./ui/button";

const STATUS = {
  online: { label: "Disponible", dot: "#10B981" },
  busy: { label: "En consultation", dot: "#F59E0B" },
  offline: { label: "Absent", dot: "#9CA3AF" },
};

export function ExpertCard({ expert, onStart }) {
  const st = STATUS[expert.presence] || STATUS.offline;
  return (
    <div className="glass card-hover group relative flex flex-col overflow-hidden rounded-3xl border border-celeste-or/15" data-testid={`expert-card-${expert.id}`}>
      {expert.is_demo && (
        <div className="absolute left-3 top-3 z-10 rounded-full bg-celeste-night/80 px-2.5 py-1 text-[10px] font-medium text-celeste-or backdrop-blur">
          Profil de démonstration
        </div>
      )}
      <div className="relative h-52 overflow-hidden">
        <img src={expert.photo_url} alt={expert.professional_name} loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-celeste-night via-transparent to-transparent" />
        <div className="absolute bottom-3 left-3 flex items-center gap-1.5 rounded-full bg-celeste-night/80 px-2.5 py-1 text-xs backdrop-blur">
          <span className="relative flex h-2 w-2">
            {expert.presence === "online" && <span className="absolute inline-flex h-full w-full animate-ping rounded-full opacity-75" style={{ background: st.dot }} />}
            <span className="relative inline-flex h-2 w-2 rounded-full" style={{ background: st.dot }} />
          </span>
          <span className="text-celeste-lilas">{st.label}</span>
        </div>
      </div>

      <div className="flex flex-1 flex-col p-5">
        <div className="flex items-start justify-between gap-2">
          <div>
            <h3 className="font-serif text-lg text-celeste-ivoire">{expert.professional_name}</h3>
            <p className="text-xs text-celeste-lilas/70">{expert.title}</p>
          </div>
          <div className="flex items-center gap-1 text-sm text-celeste-or">
            <Star className="h-4 w-4 fill-celeste-or" />
            {expert.rating?.toFixed(1) || "—"}
          </div>
        </div>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {(expert.specialties || []).slice(0, 3).map((s) => (
            <span key={s} className="rounded-full border border-celeste-violet/30 bg-celeste-violet/15 px-2 py-0.5 text-[11px] text-celeste-lilas">{s}</span>
          ))}
        </div>

        <div className="mt-4 flex items-center justify-between text-sm">
          <span className="text-celeste-lilas/70">{expert.reviews_count || 0} avis · {expert.consultations_count || 0} consult.</span>
          <span className="font-semibold text-celeste-or">{expert.price_per_min} cr/min</span>
        </div>

        <div className="mt-4 flex gap-2">
          <Button asChild variant="ghost" className="flex-1 border border-celeste-violet/30 text-celeste-lilas hover:bg-celeste-violet/15">
            <Link to={`/experts/${expert.id}`} data-testid={`view-expert-${expert.id}`}>Voir le profil</Link>
          </Button>
          <Button data-testid={`start-chat-${expert.id}`} onClick={() => onStart?.(expert)}
            disabled={expert.presence !== "online"}
            className="flex-1 gold-btn font-semibold disabled:opacity-40">
            <MessageCircle className="mr-1.5 h-4 w-4" /> Chat
          </Button>
        </div>
      </div>
    </div>
  );
}
